import { hasAuthCookie } from '@quintoandar/wat-cookie';

const localAuthHosts = () =>
  String(process.env.LOCAL_AUTH_HOSTS || 'localhost,127.0.0.1,dev.imudei.app')
    .split(',')
    .map((host) => host.trim())
    .filter(Boolean);

export const isLocalAuthRuntime = () =>
  localAuthHosts().includes(window.location.hostname) &&
  process.env.ENABLE_LOCAL_AUTH !== 'false';

const authCookieRemoval = (domain) =>
  `5AJWT_AUTH=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain ? `; domain=${domain}` : ''}`;

export const clearLocalAuthCookie = () => {
  document.cookie = authCookieRemoval();

  const configuredDomain = process.env.COOKIE_DOMAIN;
  if (configuredDomain && configuredDomain !== 'localhost') {
    document.cookie = authCookieRemoval(configuredDomain);
    document.cookie = authCookieRemoval(`.${configuredDomain}`);
  }

  if (window.location.hostname !== 'localhost') {
    document.cookie = authCookieRemoval(window.location.hostname);
  }
};

export const isAuthenticatedLocally = () => {
  if (!isLocalAuthRuntime()) {
    return hasAuthCookie();
  }

  return hasAuthCookie();
};
